import { QueryCache, QueryClient } from "@tanstack/react-query";

import { reportFailure, reportSuccess } from "./liveness";
import { isProblem } from "./problem";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    // Every query tells the shell whether the services are answering.
    queryCache: new QueryCache({
      onSuccess: () => {
        reportSuccess();
      },
      onError: (error) => {
        reportFailure(error);
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        // A 4xx says the same thing however often it is asked. Only "no
        // answer" and 5xx are worth another try.
        retry: (failureCount, error) => {
          if (isProblem(error) && error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        },
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
      },
      mutations: {
        // A write is repeated by the person, with the same Idempotency-Key,
        // never silently.
        retry: false,
      },
    },
  });
}
